import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import './App.css';
import Register from './components/Register';
import DashboardLayout from './components/DashboardLayout';
import EmployeeDashboard from './components/dashboard/EmployeeDashboard';
import AdminDashboard from './components/dashboard/AdminDashboard';
import Attendance from './components/employee/Attendance';
import DueCustomer from './components/admin/DueCustomer';
import TotalCustomer from './components/admin/TotalCustomer';
import MyAttendance from './components/employee/MyAttendance';
import NewProject from './components/pages/NewProject';
import OldProject from './components/pages/OldProject';
import CompleteProject from './components/pages/CompleteProject';
import FollowupList from './components/Customer/FollowupList';
import DoneListSales from './components/Customer/DoneListSales';
import TodayFollowuplist from './components/Customer/TodayFollowupList';
import CustomerCreate from './components/Customer/CustomerCreate';
import AddRemark from './components/Customer/AddRemark';
import ProtectedRoute from './components/ProtectedRoute';
import CustomerMarkDone from './components/Customer/CustomerMarkDone';
import CustomerEdit from './components/Customer/CustomerEdit';
import CustomerEditAfterDone from './components/Customer/CustomerEditAfterDone';
import EmployeeAttendanceReport from './components/admin/EmployeeAttendanceReport';
import AdminAttendancePage from './components/admin/AdminAttendancePage';
import EmployeeManagement from './components/admin/EmployeeManagement';
import LeaveManagement from './components/admin/LeaveManagement';
import LeaveApplication from './components/employee/LeaveApplication';
import MyLeaves from './components/employee/MyLeaves.';
import MySalarySlips from './components/employee/MySalarySlips';
import Profile from './components/employee/Profile';
import SalaryManagement from './components/admin/SalaryManagement';
import API from './api';
import NoticeBoard from './components/admin/NoticeBoard';
import HolidayManager from './components/admin/HolidayManager';
import SaleryAdvance from './components/salery/SaleryAdvance';
import EmployeeDetailView from './components/admin/EmployeeDetailView';
import { useCustomers } from './components/context/CustomerContext';
import ProjectDetails from './components/admin/ProjectDetails';
import ProjectShareOnly from './components/pages/ProjectShareOnly';


const getInitialUser = () => {
  try {
    const storedUser = localStorage.getItem('employee');
    return storedUser && storedUser !== 'undefined' ? JSON.parse(storedUser) : null;
  } catch (error) {
    console.error('Failed to parse user:', error);
    return null;
  }
};

function App() {
  const [user, setUser] = useState(getInitialUser());
  const [isAuthChecked, setIsAuthChecked] = useState(false);
  const [isAuthenticated, setIsAuthenticated] = useState(false);


  useEffect(() => {
    const verifyToken = async () => {
      const token = localStorage.getItem('token');
      if (!token) {
        setIsAuthenticated(false);
        setUser(null);
        setIsAuthChecked(true);
        return;
      }

      try {
        await API.get('/auth/verify'); // ✅ Backend token verification
        const storedUser = JSON.parse(localStorage.getItem('employee'));
        setUser(storedUser);
        setIsAuthenticated(true);
      } catch (err) {
        console.error('Token verification failed:', err);
        localStorage.removeItem('token');
        localStorage.removeItem('employee');
        setUser(null);
        setIsAuthenticated(false);
      } finally {
        setIsAuthChecked(true);
      }
    };

    verifyToken();
    
  }, []);

  const onLogout = () => {
    localStorage.removeItem('employee');
    localStorage.removeItem('token');
    setUser(null);
    setIsAuthenticated(false);
  };

  const handleUserUpdate = (updatedUser) => {
    setUser(updatedUser);
    localStorage.setItem('employee', JSON.stringify(updatedUser));
  };

  if (!isAuthChecked) {
    return <div className="text-center mt-10 text-lg font-semibold">Loading...</div>;
  }

  return (
    <Router>
      <Routes>
        {/* ✅ Root path now checks localStorage */}
        <Route
          path="/"
          element={
            localStorage.getItem('token') && localStorage.getItem('employee')
              ? <Navigate to="/dashboard" />
              : <Navigate to="/login" />
          }
        />

        {/* Login and Register */}
        <Route path="/login" element={<Register setUser={setUser} />} />
        <Route path="/register" element={<Register setUser={setUser} />} />

        {/* Protected dashboard routes */}
        <Route
          path="/dashboard/*"
          element={
            <ProtectedRoute isAuthenticated={isAuthenticated}>
              <DashboardLayout user={user} onLogout={onLogout} />
            </ProtectedRoute>
          }
        >
          {/* ✅ Common Routes */}
          <Route path="attendance" element={<Attendance />} />
          <Route path="my-attendance" element={<MyAttendance />} />
          <Route path="customers/:id/edit" element={<CustomerEdit />} />
          <Route path="doneCustomers/:id/edit" element={<CustomerEditAfterDone />} />
          <Route path="profile" element={<Profile user={user} onUserUpdate={handleUserUpdate} />} />

          {/* 🔐 Admin Only */}
          {user?.department === 'Management' && (
            <>
              <Route path="" element={<AdminDashboard user={user} />} />
              <Route path="notices" element={<NoticeBoard />} />
              <Route path="create-customer" element={<CustomerCreate />} />
              <Route path="today-followup" element={<TodayFollowuplist />} />
              <Route path="followup-list" element={<FollowupList />} />
              <Route path="due-customer" element={<DueCustomer />} />
              <Route path="total-customer" element={<TotalCustomer />} />
              <Route path="employee-management" element={<EmployeeManagement />} />
              <Route path="leave-management" element={<LeaveManagement user={user} />} />
              <Route path="salary-management" element={<SalaryManagement />} />
              <Route path="remarks/add/:id" element={<AddRemark />} />
              <Route path="customers/:customerId/done" element={<CustomerMarkDone />} />
              <Route path="employee/:id/attendance" element={<EmployeeAttendanceReport />} />
              <Route path="employee-attendance" element={<AdminAttendancePage />} />
              <Route path="holidayManager" element={<HolidayManager />} />
              <Route path="Salary-Advance" element={<SaleryAdvance user={user} />} />
              <Route path="employee/view/:id" element={<EmployeeDetailView />} />
              <Route path="projects_details" element={<ProjectDetails />} />
            </>
          )}

          {/* 🔐 Sales Only */}
          {user?.department === 'Sales' && (
            <>
              <Route path="" element={<EmployeeDashboard user={user} />} />
              <Route path="create-customer" element={<CustomerCreate />} />
              <Route path="today-sales-followup" element={<TodayFollowuplist />} />
              <Route path="followup-list" element={<FollowupList />} />
              <Route path="done-list" element={<DoneListSales />} />
              <Route path="remarks/add/:id" element={<AddRemark />} />
              <Route path="customers/:customerId/done" element={<CustomerMarkDone />} />
              <Route path="leave-application" element={<LeaveApplication user={user} onLeaveApplied={() => {}} />} />
              <Route path="my-leaves" element={<MyLeaves user={user} />} />
              <Route path="my-salary-slips" element={<MySalarySlips user={user} />} />
              <Route path="All-Projects" element={<ProjectShareOnly />} />
            </>
          )}

          {/* 🔐 Developer Only */}
          {user?.department === 'Developer' && (
            <>
              <Route path="" element={<EmployeeDashboard user={user} />} />
              <Route path="new-project" element={<NewProject user={user} />} />
              <Route path="old-project" element={<OldProject user={user} />} />
              <Route path="complete-project" element={<CompleteProject user={user} />} />
              <Route path="leave-application" element={<LeaveApplication user={user} onLeaveApplied={() => {}} />} />
              <Route path="my-leaves" element={<MyLeaves user={user} />} />
              <Route path="my-salary-slips" element={<MySalarySlips user={user} />} />
              <Route path="All-Projects" element={<ProjectShareOnly />} />
            </>
          )}
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
